// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2031j","right":"Footer_right__3Qc7G","buttons":"Footer_buttons__3sBy7"};